import type { ValidationProblemDetails } from './http';

export interface ContactSubmission {
  ticketId: string;
}

export interface ContactValidationError {
  type: string;
  title: string;
  status: 400;
  errors: Record<string, string[]>;
  traceId: string;
}

export interface ContactSubmissionRequest {
  topic?: string;
  subject?: string;
  description?: string;
  ticketType?: number;
}

// For compatibility with the rest of your codebase
export type ContactValidationProblem = ValidationProblemDetails;

// Kept for import compatibility in other files:
export interface ContactPostError {
  status: 400;
  payload: ValidationProblemDetails;
}

export function isContactPostError(
  value: unknown,
): value is Error & { status: 400; payload: ValidationProblemDetails } {
  if (!(value instanceof Error)) return false;

  const record = value as unknown as Record<string, unknown>;
  if (record['status'] !== 400) return false;

  const payload = record['payload'];
  if (
    !payload ||
    typeof payload !== 'object' ||
    (payload as { status?: unknown }).status !== 400
  ) {
    return false;
  }

  // Must have an errors object: Record<string, string[]>
  const errors = (payload as { errors?: unknown }).errors;
  if (!errors || typeof errors !== 'object') return false;

  // Light validation that values are arrays of strings
  const entries = Object.entries(errors as Record<string, unknown[]>);
  return entries.every(([, arr]) => Array.isArray(arr));
}
